import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { Alert, AlertDescription } from "./ui/alert";
import { 
  GitBranch, 
  AlertCircle
} from "lucide-react";

const ContractFlowVisualizer = ({ calculationId, contracts, contractAllocations, allocationResults }) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <GitBranch className="h-5 w-5 text-teal-600" />
            <span>Contract Allocation Flow Visualizer</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center py-8">
          <GitBranch className="h-16 w-16 mx-auto mb-4 text-slate-300" />
          <h3 className="text-lg font-medium mb-2 text-slate-600">Flow Visualization</h3>
          <p className="text-sm text-slate-500 mb-4">
            Visual representation of allocation flow from company-wide pools to individual contracts.
          </p>
          <Badge variant="outline" className="text-xs">Coming Soon</Badge>
        </CardContent>
      </Card>

      <div className="p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-slate-600">
          <AlertCircle className="h-4 w-4" />
          <div>
            <p className="font-medium">Flow Visualizer Information</p>
            <ul className="text-xs mt-1 space-y-1">
              <li>• Visual Flow: Interactive diagram showing pool-to-contract allocation paths</li>
              <li>• Allocation Methods: Shows how each indirect pool is distributed to contracts</li>
              <li>• Professional Presentation: Clear visualization for audit and review purposes</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractFlowVisualizer;